import React from 'react';
import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';

// Silent error boundary - captures errors to Sentry without any UI
const SentryErrorBoundary = ({ children }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={() => null} // Silent - no UI shown
      beforeCapture={(scope, error, errorInfo) => {
        scope.setTag('errorBoundary', true);
        scope.setContext('errorInfo', errorInfo);
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

SentryErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};

export default SentryErrorBoundary;
